export default __webpack_public_path__ + "static/insta1-d53b93cc6ffcc78bab8eb648e9a88de8.png";